import { Promotion } from '../../../../stores/promotion';
import style from '../../style.module.scss';

const renderUsagePercentage = (_: unknown, record: Promotion) => {
    if (
        record.type !== 'coupon' ||
        record.quantity == null ||
        record.quantity <= 0 ||
        record.activationsCount == null
    ) {
        return <span className={style.not_applicable}>-</span>;
    }

    const percentageUsed = Math.round(
        (record.activationsCount / record.quantity) * 100
    );

    return <div className={style.percentage_used}>{percentageUsed}%</div>;
};

export default renderUsagePercentage;
